module.exports = __webpack_public_path__ + "static/aboutIllustration-c2c435c71987f0625d668b17ef8beae9.png";